import type { SalesDateRange } from '../../../../api/daily-sales';
import { useViewport } from '../../../../hooks/useViewport';
import { SegmentedControl } from '../../primitives';
import {
  defaultRange,
  RANGE_PRESETS,
  RANGE_PRESETS_SHORT,
  type RangePreset,
} from '../daily-sales-range';

import { DailySalesCustomDates } from './DailySalesCustomDates';

interface DailySalesRangePickerProps {
  today: string;
  range: SalesDateRange | null;
  preset: RangePreset;
  /** What the report on screen covers, or what is loading. Empty when the dates were refused. */
  summary: string;
  onPreset: (preset: RangePreset) => void;
  onApply: (range: SalesDateRange) => void;
}

export function DailySalesRangePicker({
  today,
  range,
  preset,
  summary,
  onPreset,
  onApply,
}: DailySalesRangePickerProps) {
  const { isPhone } = useViewport();
  const initial = range ?? defaultRange(today);

  return (
    <section className="nb-card nb-ds-range" aria-label="Dates">
      <div className="nb-ds-range-row">
        <SegmentedControl
          value={preset}
          onChange={onPreset}
          options={isPhone ? RANGE_PRESETS_SHORT : RANGE_PRESETS}
          ariaLabel="Dates shown"
        />
        <span className="nb-ds-range-summary" aria-live="polite">
          {summary}
        </span>
      </div>
      {preset === 'custom' && (
        <DailySalesCustomDates
          key={`${initial.from}|${initial.to}`}
          initial={initial}
          today={today}
          onApply={onApply}
        />
      )}
    </section>
  );
}
